export interface InfoBadgePayload {
  name: string;
  value?: string;
}

export class InfoBadge {
  private readonly el: HTMLElement;
  private readonly nameEl: HTMLSpanElement;
  private readonly valueEl: HTMLSpanElement;

  constructor(el: HTMLElement) {
    this.el = el;
    el.classList.add('info-badge');
    el.innerHTML = `<span class="dot"></span><span class="name"></span><span class="len"></span>`;
    this.nameEl = el.querySelector('.name') as HTMLSpanElement;
    this.valueEl = el.querySelector('.len') as HTMLSpanElement;
  }

  show(payload: InfoBadgePayload): void {
    this.nameEl.textContent = payload.name;
    this.valueEl.textContent = payload.value ?? '';
    this.el.classList.add('show');
  }

  hide(): void {
    this.el.classList.remove('show');
  }
}
